/* eslint-env browser */
let scrollbarWidth
const getScrollbarWidth = () => { // eslint-disable-line no-unused-vars
  fastdom.mutate(() => {
    const outer = document.createElement('div')
    outer.style.visibility = 'hidden'
    outer.style.width = '100px'
    outer.style.msOverflowStyle = 'scrollbar'

    const inner = document.createElement('div')
    inner.style.width = '100%'

    document.body.appendChild(outer)
    fastdom.measure(() => {
      const widthNoScroll = outer.offsetWidth
      fastdom.mutate(() => {
        outer.style.overflow = 'scroll'
        outer.appendChild(inner)

        fastdom.measure(() => {
          const widthWithScroll = inner.offsetWidth

          scrollbarWidth = widthNoScroll - widthWithScroll

          fastdom.mutate(() => {
            outer.parentNode.removeChild(outer)
          })
        })
      })
    })
  })
}

getScrollbarWidth()

window.addEventListener('resize', getScrollbarWidth, false)
